import React from "react";

function Footer() {
	return (
		<div className="coded-by text-center text-uppercase mt-5">
			<p>Coded by Wynn.Codes</p>

			<div className="mb-3">
				<a
					href="https://www.linkedin.com/in/louise-fong"
					title="LinkedIn"
					target="_blank"
				>
					<i className="my-links fa-brands fa-linkedin"></i>
				</a>
				<a
					href="https://www.instagram.com/wynn.codes/"
					title="Instagram"
					target="_blank"
				>
					<i className="my-links fa fa-instagram"></i>
				</a>
			</div>
		</div>
	);
}

export default Footer;
